import {ErrorHandler, Injectable} from "@angular/core";
import {environment} from "../../../environment";
import * as Sentry from "@sentry/angular";

@Injectable()

export class SentryErrorHandler {
  handleError(error: any) {
    Sentry.captureException(error.originalError || error);
  }
}

export function getErrorHandler(): ErrorHandler {
  if (environment.production) {
    return new SentryErrorHandler();
  }

  return new ErrorHandler();
}
